// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IUpdatePayoutRuleTypeDto } from './IUpdatePayoutRuleTypeDto';
import {
    IUpdatePayoutRuleTypeDtoFromJSON,
    IUpdatePayoutRuleTypeDtoFromJSONTyped,
    IUpdatePayoutRuleTypeDtoToJSON,
    IUpdatePayoutRuleTypeDtoToJSONTyped,
} from './IUpdatePayoutRuleTypeDto';

/**
 * 
 * @export
 * @interface IUpdatePayoutRuleTypeRequestDto
 */
export interface IUpdatePayoutRuleTypeRequestDto {
    /**
     * 
     * @type {Array<IUpdatePayoutRuleTypeDto>}
     * @memberof IUpdatePayoutRuleTypeRequestDto
     */
    tiers: Array<IUpdatePayoutRuleTypeDto>;
}

/**
 * Check if a given object implements the IUpdatePayoutRuleTypeRequestDto interface.
 */
export function instanceOfIUpdatePayoutRuleTypeRequestDto(value: object): value is IUpdatePayoutRuleTypeRequestDto {
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function IUpdatePayoutRuleTypeRequestDtoFromJSON(json: any): IUpdatePayoutRuleTypeRequestDto {
    return IUpdatePayoutRuleTypeRequestDtoFromJSONTyped(json, false);
}

export function IUpdatePayoutRuleTypeRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUpdatePayoutRuleTypeRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'tiers': ((json['tiers'] as Array<any>).map(IUpdatePayoutRuleTypeDtoFromJSON)),
    };
}

export function IUpdatePayoutRuleTypeRequestDtoToJSON(json: any): IUpdatePayoutRuleTypeRequestDto {
    return IUpdatePayoutRuleTypeRequestDtoToJSONTyped(json, false);
}

export function IUpdatePayoutRuleTypeRequestDtoToJSONTyped(value?: IUpdatePayoutRuleTypeRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tiers': ((value['tiers'] as Array<any>).map(IUpdatePayoutRuleTypeDtoToJSON)),
    };
}

